import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { DualViewRefModel } from './models/dual-view-ref-model';
import { DualViewRefModelImpl } from './models/impls/dual-view-ref-model';
import { DualViewSettingModel } from './models/dual-view-setting-model';
import { DualViewSettingModelImpl } from './models/impls/dual-view-setting-model';
import { DualViewSettingService } from './services/dual-view-setting-service';
import { DualViewSettingServiceImpl } from './services/impls/dual-view-setting-service';
import { DualViewRefService } from './services/dual-view-ref-service';
import { DualViewRefServiceImpl } from './services/impls/dual-view-ref-service';

export const dualViewModule = (bind: interfaces.Bind) => {
    bind(DualViewRefModel).to(DualViewRefModelImpl);
    bind(DualViewSettingModel).to(DualViewSettingModelImpl);
    bind(DualViewSettingService).to(DualViewSettingServiceImpl);
    bind(DualViewRefService).to(DualViewRefServiceImpl);
};
